.cv{border:1px solid #ddd;}